import DocumentModal  from './DocumentModal.vue'
export default DocumentModal
